'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.highestOwnedEditionAcrossAllHubsSelector = exports.highestOwnedEditionInHubSelector = exports.isUnactivatedFreeProductSelector = exports.highestOwnedMerchIdInHubSelector = exports.ownsProductOrHigherSelector = exports.hasHigherTieredProductSelector = exports.ownsProductSelector = exports.parcelsSelector = undefined;

var _immutable = require('immutable');

var _isProductOwnedAdapter = require('self-service-api/adapters/isProductOwnedAdapter');

var _isProductOwnedAdapter2 = _interopRequireDefault(_isProductOwnedAdapter);

var _hasHigherTieredProductAdapter = require('self-service-api/adapters/hasHigherTieredProductAdapter');

var _hasHigherTieredProductAdapter2 = _interopRequireDefault(_hasHigherTieredProductAdapter);

var _validators = require('self-service-api/core/validators');

var _ImmutableMerchandiseIdMap = require('self-service-api/constants/ImmutableMerchandiseIdMap');

var _ImmutableMerchandiseIdMap2 = _interopRequireDefault(_ImmutableMerchandiseIdMap);

var _HubMap = require('self-service-api/constants/HubMap');

var _HubMap2 = _interopRequireDefault(_HubMap);

var _Hubs = require('self-service-api/constants/Hubs');

var _Hubs2 = _interopRequireDefault(_Hubs);

var _Editions = require('self-service-api/constants/Editions');

var _freeProductUtils = require('../utils/freeProductUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var isActiveParcel = function isActiveParcel(parcel) {
  return parcel.quantity !== 0;
};

var parcelsSelector = exports.parcelsSelector = function parcelsSelector(_ref) {
  var parcels = _ref.parcels;
  return parcels && parcels.filter(isActiveParcel);
};

var ownsProductSelector = exports.ownsProductSelector = function ownsProductSelector(state, merchandiseId) {
  if (!merchandiseId) return false;

  var merchandise = state.merchandise;

  var parcels = parcelsSelector(state);
  (0, _validators.validateMerchandiseId)(merchandiseId);

  if (!merchandise) {
    return false;
  }

  var productData = {
    products: merchandise
  };

  return (0, _isProductOwnedAdapter2.default)(productData, parcels, merchandiseId);
};

var hasHigherTieredProductSelector = exports.hasHigherTieredProductSelector = function hasHigherTieredProductSelector(state, merchandiseId) {
  var merchandise = state.merchandise;

  var parcels = parcelsSelector(state);

  (0, _validators.validateMerchandiseId)(merchandiseId);

  if (!merchandise) {
    return false;
  }

  var productData = {
    products: merchandise
  };

  return (0, _hasHigherTieredProductAdapter2.default)(productData, parcels, merchandiseId);
};

var ownsProductOrHigherSelector = exports.ownsProductOrHigherSelector = function ownsProductOrHigherSelector(state, merchandiseId) {
  return ownsProductSelector(state, merchandiseId) || hasHigherTieredProductSelector(state, merchandiseId);
};

var highestOwnedMerchIdInHubSelector = exports.highestOwnedMerchIdInHubSelector = function highestOwnedMerchIdInHubSelector(state, hub) {
  var highlightedMerchInHub = _HubMap2.default[hub].highlightedPaidMerch;
  var highestPaidMerchIdOwned = highlightedMerchInHub.find(function (merchId) {
    if (ownsProductSelector(state, merchId) && !hasHigherTieredProductSelector(state, merchId)) {
      return merchId;
    }
    return null;
  });
  var highlightedFreeMerchId = _HubMap2.default[hub].highlightedFreeMerch;
  return highestPaidMerchIdOwned || highlightedFreeMerchId;
};

var isUnactivatedFreeProductSelector = exports.isUnactivatedFreeProductSelector = function isUnactivatedFreeProductSelector(state, merchandiseId) {
  if (!(0, _freeProductUtils.isFreeProduct)(merchandiseId)) {
    return false;
  }

  var parcels = parcelsSelector(state);
  return !(0, _freeProductUtils.hasFreeProduct)(parcels, merchandiseId) && !hasHigherTieredProductSelector(state, merchandiseId);
};

var highestOwnedEditionInHubSelector = exports.highestOwnedEditionInHubSelector = function highestOwnedEditionInHubSelector(state, hub) {
  var highestOwnedMerchId = highestOwnedMerchIdInHubSelector(state, hub);
  return highestOwnedMerchId ? _ImmutableMerchandiseIdMap2.default[highestOwnedMerchId].edition : null;
};

var highestOwnedEditionAcrossAllHubsSelector = exports.highestOwnedEditionAcrossAllHubsSelector = function highestOwnedEditionAcrossAllHubsSelector(state) {
  var _OrderedMap;

  var editionOwnershipOrderedMap = (0, _immutable.OrderedMap)((_OrderedMap = {}, _defineProperty(_OrderedMap, _Editions.ENTERPRISE, false), _defineProperty(_OrderedMap, _Editions.PROFESSIONAL, false), _defineProperty(_OrderedMap, _Editions.STARTER, false), _defineProperty(_OrderedMap, _Editions.FREE, true), _OrderedMap)).asMutable();

  Object.keys(_Hubs2.default).forEach(function (hubKey) {
    var edition = highestOwnedEditionInHubSelector(state, _Hubs2.default[hubKey]);
    editionOwnershipOrderedMap.set(edition, true);
  });

  return editionOwnershipOrderedMap.findKey(function (ownsEdition) {
    return ownsEdition;
  });
};


//////////////////
// WEBPACK FOOTER
// ./js/selectors/ProductOwnershipSelectors.js
// module id = 76
// module chunks = 3 4 5